import createIcon from '@/lib/create-icon'

const SearchIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' fill='none'>
    <path
      d='M14.998 7.87772C14.998 11.8603 11.7897 15.0888 7.83203 15.0888C3.87435 15.0888 0.666016 11.8603 0.666016 7.87772C0.666016 3.89518 3.87435 0.666687 7.83203 0.666687C11.7897 0.666687 14.998 3.89518 14.998 7.87772ZM2.29726 7.87772C2.29726 10.9537 4.77526 13.4473 7.83203 13.4473C10.8888 13.4473 13.3668 10.9537 13.3668 7.87772C13.3668 4.80175 10.8888 2.30818 7.83203 2.30818C4.77526 2.30818 2.29726 4.80175 2.29726 7.87772Z'
      fill='currentColor'
    />
    <path
      d='M16.2278 17.2961C15.9494 17.287 15.6847 17.1725 15.4867 16.9754L13.7897 14.9918C13.4259 14.6591 13.3961 14.0936 13.723 13.7241V13.7241C13.876 13.5693 14.0841 13.4822 14.301 13.4822C14.518 13.4822 14.7261 13.5693 14.8791 13.7241L17.0133 15.4318C17.3207 15.7464 17.4156 16.2136 17.2555 16.6244C17.0954 17.0352 16.7103 17.3129 16.2723 17.3333L16.2278 17.2961Z'
      fill='currentColor'
      fillOpacity='0.4'
    />
  </svg>,
  'SearchIcon'
)

export default SearchIcon
